
export const invoiceReducer = (state = [], action) => {

    switch (action.type) {
        case '[INVOICE] Load list':
            return {
                ...state,
                invoices: action.payload
            }

        case '[INVOICE] set detail':
            return {
                ...state,
                detailInvoice: action.payload
            }

        default:
            return state
    }


}